export default {"src":"/_next/static/media/up-distance-icon.e6430e07.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};